module.exports = __webpack_public_path__ + "static/img/stashe-phone-bottom.27007ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device/stashe-phone-bottom.png
// module id = Mjp8
// module chunks = 0